import { Button, Form, Input, notification } from 'antd';
import { useState } from 'react';
import { PackType } from '../../../../redux/userStore/reducer';
import { ORANGE } from '../../../../shared/colors';
import { addPack } from '../../../dashboard/network';

export const PackForm = ({
  setShowDrawer,
  getNewPack,
}: {
  setShowDrawer: (b: boolean) => void;
  getNewPack: (part: PackType) => void;
}) => {
  const [form] = Form.useForm();
  const [isLoading, setIsLoading] = useState(false);
  // const connectedUser = new ConnectedUserEntity(
  //   useSelector((state: any) => state.userReducer).user,
  // );

  return (
    <div>
      <Form
        layout='vertical'
        style={{ listStyleType: 'none' }}
        form={form}
        labelCol={{ span: 20 }}
        wrapperCol={{ span: 25 }}
        onFinish={async (data) => {
          setIsLoading(true);
          await addPack(data).then(({ statusCode, data }) => {
            if (statusCode?.toString()[0] === '2') {
              notification.success({
                message: 'Succès',
                description: 'Le pack a été créé avec succès',
              });
              getNewPack(data);
              setShowDrawer(false);
            } else {
              notification.info({
                message: 'Erreur',
                description: data.message,
              });
            }
            setIsLoading(false);
          });
        }}
      >
        <Form.Item
          label='Nom du pack'
          name='nom'
          hasFeedback
          rules={[
            {
              required: true,
              message: 'Entrez le nom du pack',
            },
          ]}
        >
          <Input placeholder='Entrez le nom du pack' />
        </Form.Item>
        <Form.Item
          label='Cout du pack'
          name='amount'
          hasFeedback
          rules={[
            {
              required: true,
              message: 'Entrez le montant du pack',
            },
          ]}
        >
          <Input placeholder='Entrez la montant' type='number' min={0} />
        </Form.Item>
        <Form.Item
          label='Durée du pack (En année)'
          name='duree_an'
          hasFeedback
          rules={[
            {
              required: true,
              message: 'Entrez la durée du pack',
            },
          ]}
        >
          <Input placeholder='Entrez la durée' type='number' min={0} />
        </Form.Item>
        <Form.Item>
          <Button
            type='primary'
            htmlType='submit'
            // size='large'
            loading={isLoading}
            style={{
              width: '50%',
              backgroundColor: ORANGE,
              borderWidth: 0,
              borderRadius: 5,
              marginBottom: 20,
            }}
          >
            Enregistrer
          </Button>
        </Form.Item>
      </Form>
    </div>
  );
};
